/**
 * N’affiche les enfants qu’après facturxAuthReady (SSO + ping Factures).
 * Pendant le boot, le kit suite-shared montre déjà ses modales — on reste vide.
 */
import { useEffect, useState, type ReactNode } from "react";
import { readUserId } from "../suiteSession";

type AuthGateProps = {
  children: (userId: string) => ReactNode;
};

export function AuthGate({ children }: AuthGateProps) {
  const [userId, setUserId] = useState("");

  useEffect(() => {
    const onReady = (ev: Event) => {
      const id = (ev as CustomEvent<{ userId?: string }>).detail?.userId || window.__facturxHub2UserId || readUserId();
      setUserId(id);
    };
    const onLost = () => setUserId("");
    window.addEventListener("facturxAuthReady", onReady);
    window.addEventListener("facturxAuthLost", onLost);
    if (window.__facturxSessionVerified) {
      setUserId(window.__facturxHub2UserId || readUserId());
    }
    return () => {
      window.removeEventListener("facturxAuthReady", onReady);
      window.removeEventListener("facturxAuthLost", onLost);
    };
  }, []);

  if (!userId) return null;
  return <>{children(userId)}</>;
}
